<script lang="ts">
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import SbRichtext from '../components/sbRichtext.svelte';
	import { editable } from '../editable';

	interface Props {
		content: ISbStoryData<{
			text: ISbRichtext;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div use:editable={content} class="my-5 text-[12px]/[130%] text-brown-3">
	<SbRichtext text={content.text} />
</div>
